// eslint-disable-next-line import/prefer-default-export
export const GET_SERVICE_CART = 'GET_SERVICE_CART';
export const RESET_SERVICE_CART = 'RESET_SERVICE_CART';
